import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgxImageCompressService } from "ngx-image-compress";
import { CrudWImageForm } from "src/app/components/shared/cruds/crud-w-image.form";
import { TiposMaterialDTO } from "src/app/models/tipo-material.dto";
import { BlackListService } from "../blacklist.service";
import { CURP_REGEX } from "src/app/utils/constants";

@Component({
  selector: "app-form-drawer-blacklist",
  templateUrl: "./drawer-form.component.html",
})
export class BlackilistDrawerForm
  extends CrudWImageForm<TiposMaterialDTO>
  implements OnInit
{
  public curpRegex = CURP_REGEX;
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: any;
  };
  constructor(
    public fb: FormBuilder,
    public service: BlackListService,
    private compress: NgxImageCompressService,
  ) {
    super(fb, compress);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
        this.valueImg = null;
      }
    }
  }

  // TODO add validators
  public buildForm() {
    this.form = this.fb.group({
      IdBlackList: [""],
      Nombre: ["", [Validators.required]],
      Razon: [""],
      CURP: ["", [Validators.required, Validators.pattern(this.curpRegex)]],
    });
  }
  public fromInit(row: any) {
    this.form.controls["IdBlackList"].setValue(row?.IdBlackList);
    this.form.controls["Nombre"].patchValue(row?.Nombre);
    this.form.controls["Razon"].patchValue(row?.Razon);
    this.form.controls["CURP"].patchValue(row?.CURP);
  }

  public loadImage() {
    this.service.image(this.defaults.IdBlackList).subscribe(
      (str) => (this.valueImg = str),
      (err) => (this.valueImg = null),
    );
  }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
        file: this.imageFile,
      },
    });
  }

  imageFile: File | null = null;

  onImageSelected(file: File | null) {
    this.imageFile = file;
  }
}
